/** @jsxImportSource @emotion/react */

import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { IconButton } from '@mui/material'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import Table, { FooterWrapper, HeaderWrapper, PaginationPage, PaginationTake } from 'components/Table'
import { Search } from 'components/Input'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { searchTemplateQuestion_searchTemplateQuestion_items } from '__generatedTypes__/searchTemplateQuestion'
import { useQuestionPassageTemplates } from './useQuestionPassageTemplates'
import * as classes from './styles'

export const TemplateList = () => {
  const { getLink } = useLink()
  const templatesState = useQuestionPassageTemplates()
  const { items, loading, refetch, pagination, search, loaded } = templatesState

  useEffect(() => {
    refetch()
  }, [refetch])

  return (
    <div css={classes.container}>
      <HeaderWrapper css={classes.headerWrapper}>
        <Search {...search} css={classes.search} />
        <PaginationPage {...pagination} />
      </HeaderWrapper>
      <Table
        css={classes.tableWrapper}
        columns={[
          {
            title: 'Template Name',
            renderCell: (questionTemplate) => (
              <div css={classes.titleWrapper}>
                <div>{questionTemplate.templateName}</div>
              </div>
            ),
            flex: 2,
          },
          {
            title: 'Date Added',
            renderCell: (questionTemplate) => new Date(questionTemplate.createdAt).toLocaleDateString(),
          },
          {
            title: '',
            renderCell: (questionTemplate) => (
              <Link to={getLink(cmsRoutes.CARS_QUESTION_TEMPLATE_EDIT, { templateId: questionTemplate.id })}>
                <IconButton size="small" css={classes.action} disabled={loading}>
                  <EditIcon />
                </IconButton>
              </Link>
            ),
            flex: '0 1 64px',
          },
        ]}
        items={items as searchTemplateQuestion_searchTemplateQuestion_items[]}
        wrapperMinWidth={500}
        isNotLoaded={!loaded}
      />
      <FooterWrapper>
        <PaginationTake {...pagination} css={classes.paginationTake} />
      </FooterWrapper>
    </div>
  )
}
